import React, { useState } from "react";
import { Loader2, ImageOff } from "lucide-react";

// Premium (Navy & Silver) image thumbnail. Shows a shimmering navy skeleton with
// a silver spinner while the photo loads, and a graceful fallback if it fails —
// so freshly-imported phone photos never appear as blank white frames.
export const PhotoThumb = ({ src, alt = "", className = "", testid }) => {
  const [status, setStatus] = useState("loading"); // loading | ready | error
  return (
    <>
      {status !== "ready" && (
        <div
          className="photo-skeleton absolute inset-0 flex items-center justify-center"
          data-testid={testid ? `${testid}-skeleton` : undefined}
          aria-hidden="true"
        >
          {status === "error"
            ? <ImageOff size={20} strokeWidth={1.75} className="text-[#C9D2DC]/70" />
            : <Loader2 size={20} strokeWidth={2} className="animate-spin text-[#C9D2DC]" />}
        </div>
      )}
      <img
        src={src}
        alt={alt}
        data-testid={testid}
        loading="lazy"
        onLoad={() => setStatus("ready")}
        onError={() => setStatus("error")}
        className={`${className} transition-opacity duration-500 ${status === "ready" ? "opacity-100" : "opacity-0"}`}
      />
    </>
  );
};

export default PhotoThumb;
